import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  GET_CURRENT_USER,
  GET_CURRENT_USER_SUCCESS,
  GET_CURRENT_USER_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  remember_me: false,
  account_id: null,
  current_user: null
}

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        error: "",
        loading: true,
      }
      break
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: "",
        account_id: action.payload.memberships[0].account.id,
        current_user: action.payload
      }
      break
    case LOGOUT_USER:
      state = { ...state, loading: true, error: null }
      break
    case LOGOUT_USER_SUCCESS:
      state = {
        ...state,
        account_id: null,
        loading: false,
        error: null
      }
      break
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_CURRENT_USER:
      state = {
        ...state,
        loading: true,
        error: null
      }
      break
    case GET_CURRENT_USER_SUCCESS:
      state = {
        ...state,
        current_user: action.payload,
        loading: false
      }
      break
    case GET_CURRENT_USER_ERROR:
      state = {
        ...state,
        loading: false,
        error: action.payload
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default login
